import Blockquote from "@tiptap/extension-blockquote"
import { liftTarget } from "@tiptap/pm/transform"

import type { Node as ProseMirrorNode } from "@tiptap/pm/model"

export const ToggleableBlockquote = Blockquote.extend({
	addKeyboardShortcuts() {
		return {
			"Mod-Shift-.": () => this.editor.commands.toggleBlockquote(),
		}
	},

	addCommands() {
		return {
			...this.parent?.(),
			// The stock toggle only unwraps when the whole selection sits inside one
			// quote. Select-all over a quote wrapped a second quote around it, and
			// the stuck outer quote could never be lifted off again.
			toggleBlockquote:
				() =>
				({ state, tr, dispatch, commands }) => {
					const { $from, $to, from, to } = state.selection
					const inside = $from.blockRange(
						$to,
						(node) => node.type === this.type,
					)
					const target = inside ? liftTarget(inside) : null
					if (inside && target != null) {
						if (dispatch) tr.lift(inside, target)
						return true
					}

					const quotes: { pos: number; node: ProseMirrorNode }[] = []
					state.doc.nodesBetween(from, to, (node, pos) => {
						if (node.type !== this.type) return true
						quotes.push({ pos, node })
						return false
					})
					if (quotes.length === 0) return commands.wrapIn(this.name)

					if (dispatch) {
						for (const { pos, node } of quotes.reverse()) {
							tr.replaceWith(pos, pos + node.nodeSize, node.content)
						}
					}
					return true
				},
		}
	},
})
